export const ASSETPACK_KEYS = {
  BOOT: ['boot_data', 'boot_spritesheets', 'boot_backgrounds'],
  LOAD: ['ui', 'audiosprites', 'music', 'backgrounds'],
};
